module.exports = __webpack_public_path__ + "img/e85f27d69e3c4e9e8696e156e2fad8ca.d786286f.jpg";